/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const o=o=>"string"==typeof o&&"svg"===o.toLowerCase();export{o as isSVGTag};
//# sourceMappingURL=is-svg-tag.js.map
